import { render, staticRenderFns } from "./PoliceBookModal.vue?vue&type=template&id=4cb834cf"
import script from "./PoliceBookModal.vue?vue&type=script&lang=js"
export * from "./PoliceBookModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports